// extracted by mini-css-extract-plugin
export default {"root":"Spinner__root--2ThLn","spin":"Spinner__spin--JlTLN"};